import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, Loader, Button, Statistic, Segment, Divider } from 'semantic-ui-react';
import Header from 'components/Header';
import API from 'utils/api';
import formatter from 'utils/formatter';

class EarningsPage extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      earningsData: [],
      isLoading: true,
      error: null,
      earningsPeriod: 'daily',
      showPeriodOptions: false
    };
  }

  componentDidMount() {
    this.fetchEarningsData();
  }
  
  fetchEarningsData = () => {
    console.log(`Fetching ${this.state.earningsPeriod} earnings data...`);
    this.setState({ isLoading: true });
    
    let apiCall;
    switch(this.state.earningsPeriod) {
      case 'weekly':
        apiCall = API.getOwnerWeeklyReports();
        break;
      case 'monthly':
        apiCall = API.getOwnerMonthlyReports();
        break;
      default:
        apiCall = API.getOwnerDailyReports();
    }
    
    apiCall
      .then(response => {
        console.log('Earnings data response:', response.data);
        this.setState({
          earningsData: response.data,
          isLoading: false
        });
      })
      .catch(error => {
        console.error('Error fetching earnings:', error);
        this.setState({
          isLoading: false,
          error: 'Error al cargar las ganancias'
        });
      });
  };
  
  handlePeriodChange = (period) => {
    this.setState({ 
      earningsPeriod: period
    }, () => {
      this.fetchEarningsData();
    });
  };

  getPeriodTitle = () => {
    switch(this.state.earningsPeriod) {
      case 'weekly':
        return 'Tus Ganancias por Semana';
      case 'monthly':
        return 'Tus Ganancias por Mes';
      default:
        return 'Tus Ganancias por Día';
    }
  };

  render() {
    const { earningsData, isLoading, error, earningsPeriod } = this.state;
    
    if (isLoading) {
      return (
        <div style={{textAlign: 'center', marginTop: '2em'}}>
          <Loader active inline='centered' size='large'>Cargando ganancias...</Loader>
        </div>
      );
    }
    
    if (error) {
      return (
        <div style={{textAlign: 'center', marginTop: '2em', color: 'red'}}>
          {error}
        </div>
      );
    }
    
    const today = new Date();
    const formattedDate = new Intl.DateTimeFormat('es-ES', { 
      day: 'numeric',
      month: 'long'
    }).format(today);
    
    // Calculate total
    const totalEarnings = earningsData.reduce((sum, earning) => sum + parseFloat(earning.total || 0), 0);
    
    const periodOptions = [
      { text: 'Día', value: 'daily' },
      { text: 'Semana', value: 'weekly' },
      { text: 'Mes', value: 'monthly' },
    ];
    
    return (
      <div>
        <Header 
          text={this.getPeriodTitle()}
          subtitle={formattedDate}
        />
        
        {/* Mobile-friendly period selector */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginTop: '0.5em',
          marginBottom: '1.5em'
        }}>
          <div style={{
            display: 'flex',
            width: '100%',
            maxWidth: '350px',
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #e0e0e0'
          }}>
            {periodOptions.map(option => (
              <div
                key={option.value}
                onClick={() => this.handlePeriodChange(option.value)}
                style={{
                  flex: 1,
                  textAlign: 'center',
                  padding: '0.75rem 0',
                  cursor: 'pointer',
                  backgroundColor: earningsPeriod === option.value ? '#2185d0' : '#f9f9f9',
                  color: earningsPeriod === option.value ? 'white' : '#666',
                  fontWeight: earningsPeriod === option.value ? 'bold' : 'normal',
                  transition: 'all 0.2s ease'
                }}
              >
                {option.text}
              </div>
            ))}
          </div>
        </div>
        
        <div style={{marginTop:'1em'}}>
          {earningsData.length > 0 ? (
            <>
              {earningsData.map((earning, index) => (
                <Card fluid key={index} style={{ boxShadow: 'none', border: 'none', borderBottom: '1px solid #eee' }}>
                  <Card.Content style={{ padding: '16px 8px' }}>
                    <Statistic size='small' style={{ textAlign: 'left' }}>
                      <Statistic.Value style={{ fontSize: '1.6em', fontWeight: 'normal', textAlign: 'left', color: '#333' }}>
                        {formatter.currency(earning.total)}
                      </Statistic.Value>
                      <Statistic.Label style={{ fontSize: '1em', color: '#666', marginTop: '4px', textAlign: 'left' }}>
                        {earning.date}
                      </Statistic.Label>
                    </Statistic>
                  </Card.Content>
                </Card>
              ))}
              
              {/* Total at the bottom */}
              <div style={{ 
                padding: '16px 8px', 
                marginBottom: '2em',
                background: '#f9f9f9',
                borderRadius: '8px'
              }}>
                <Statistic size='small' style={{ textAlign: 'left', margin: 0 }}>
                  <Statistic.Value style={{ fontSize: '1.8em', fontWeight: 'bold', textAlign: 'left', color: '#000' }}>
                    {formatter.currency(totalEarnings)}
                  </Statistic.Value>
                  <Statistic.Label style={{ fontSize: '1.1em', fontWeight: 'bold', color: '#666', marginTop: '4px', textAlign: 'left' }}>
                    Total
                  </Statistic.Label>
                </Statistic>
              </div>
            </>
          ) : (
            <div style={{textAlign: 'center', marginTop: '2em', color: 'gray'}}>
              No hay ganancias que mostrar.
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(EarningsPage); 